const apiVersion = 1
let config = {
  baseUrl: function() {
    //return  'https://prothumia-hub-dot-model-signifier-297723.uc.r.appspot.com/api/v1'; // `${window.runtimeConfig.apiHost}/api/v${apiVersion}`
 
    //return  'http://localhost:3000/api/v1'
    //return 'https://prothumia-hub-dev-1-dot-model-signifier-297723.uc.r.appspot.com/api/v1'


    //return 'https://prothumia-hub-v2-dot-model-signifier-297723.uc.r.appspot.com/api/v1' 
    
    //return 'https://prothumia-hub-v1-dot-model-signifier-297723.uc.r.appspot.com/api/v1'

    //return 'https://prothumia-hub-dev-dot-model-signifier-297723.uc.r.appspot.com/api/v1'  // DEV
    //return 'https://prothumia-hub-uat-dot-model-signifier-297723.uc.r.appspot.com/api/v1'  // UAT 
    //return 'https://prothumia-etbn-hub-v1-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // eTBN 1.0
    //return 'https://prothumia-etbn-hub-v1-5-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // eTBN 1.5
    //return 'https://prothumia-etbn-hub-v1-6-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // eTBN 1.6

    return 'https://prothumia-etbn-hub-dev-mp-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // MarketPlace DEV
    //return 'https://prothumia-etbn-hub-dev-mp-uat-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // MarketPlace UAT
    //return 'https://prothumia-etbn-hub-dev-mp-prod-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // MarketPlace PROD
    //return 'https://prothumia-etbn-hub-dev-mp-prod-dot-model-signifier-297723.uc.r.appspot.com/api/v1' // MarketPlace PROD

    //https://bibliotech-hub-prod-dot-model-signifier-297723.uc.r.appspot.com/
    
  
  },
  lcpUrl: function() {
    return 'http://35.226.47.75:8901';
  },
  axiosOrganizationConfig: function(organizationId) {
    return {
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        Authorization: (function() { return 'Bearer ' + localStorage.token})(),
        OrganizationId:  (function() { return organizationId})(),
        'Access-Control-Allow-Origin': '*'
      },
    }
  },
  axiosConfig: function() {
    return {
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        Authorization: (function() { return 'Bearer ' + localStorage.token})(),
        OrganizationId:  (function() { return localStorage.organizationId})(),
        'Access-Control-Allow-Origin': '*'
      },

      headerLogin: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      fileHeaders: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'multipart/form-data',
        /*Authorization: (function() {
          return 'Bearer ' + localStorage.token
        })(),*/
        'Access-Control-Allow-Origin': '*'
      },
      lcpHeaders: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'authorization': 'Basic YWRtaW46YWRtaW4xMjM=',
        /*Authorization: (function() {
          return 'Bearer ' + localStorage.token
        })(),*/
        'Access-Control-Allow-Origin': '*'
      }
    }
  }
}

export default config


// WEBPACK FOOTER //
// ./src/api/api.config.js